/**
 * @generated SignedSource<<d3be4ecb6648d83008f2064a55dba3f7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type account_Query$variables = {};
export type account_Query$data = {
  readonly " $fragmentSpreads": FragmentRefs<"accountTab_QueryFragment" | "groupsTab_QueryFragment" | "groupsTab_UserInAccountGroupQueryFragment" | "membersTab_AccountMembersQueryFragment" | "membersTab_UserInAccountGroupQueryFragment">;
};
export type account_Query = {
  response: account_Query$data;
  variables: account_Query$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 100
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "email",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstName",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastName",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "concreteType": "UserInAccountGroup",
  "kind": "LinkedField",
  "name": "groups",
  "plural": true,
  "selections": [
    (v2/*: any*/),
    (v3/*: any*/)
  ],
  "storageKey": null
},
v8 = {
  "kind": "ClientExtension",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "__id",
      "storageKey": null
    }
  ]
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cursor",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasNextPage",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "endCursor",
  "storageKey": null
},
v12 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 200
  }
],
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "phoneNumber",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "account_Query",
    "selections": [
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "membersTab_AccountMembersQueryFragment"
      },
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "membersTab_UserInAccountGroupQueryFragment"
      },
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "groupsTab_QueryFragment"
      },
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "groupsTab_UserInAccountGroupQueryFragment"
      },
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "accountTab_QueryFragment"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "account_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AccountMemberManagementQueries",
        "kind": "LinkedField",
        "name": "AccountMemberManagement",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": [
              {
                "kind": "Literal",
                "name": "filterByGroupIds",
                "value": []
              }
            ],
            "concreteType": "AccountMembersResult",
            "kind": "LinkedField",
            "name": "AccountMembers",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "userCount",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "invitationCount",
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v0/*: any*/),
                "concreteType": "AccountMemberConnection",
                "kind": "LinkedField",
                "name": "accountMembers",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "AccountMemberEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v1/*: any*/),
                          {
                            "kind": "TypeDiscriminator",
                            "abstractKey": "__isAccountMember"
                          },
                          (v2/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "kind",
                            "storageKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "UserInAccount",
                                "kind": "LinkedField",
                                "name": "user",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "User",
                                    "kind": "LinkedField",
                                    "name": "user",
                                    "plural": false,
                                    "selections": [
                                      (v2/*: any*/),
                                      (v3/*: any*/),
                                      (v4/*: any*/),
                                      {
                                        "alias": null,
                                        "args": [
                                          {
                                            "kind": "Literal",
                                            "name": "userExtensionKind",
                                            "value": "Academies"
                                          }
                                        ],
                                        "concreteType": null,
                                        "kind": "LinkedField",
                                        "name": "extension",
                                        "plural": false,
                                        "selections": [
                                          (v1/*: any*/),
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              (v5/*: any*/),
                                              (v6/*: any*/),
                                              {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": "File",
                                                "kind": "LinkedField",
                                                "name": "avatar",
                                                "plural": false,
                                                "selections": [
                                                  {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "thumbnail",
                                                    "storageKey": null
                                                  },
                                                  (v2/*: any*/)
                                                ],
                                                "storageKey": null
                                              },
                                              {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "sumGamificationPoints",
                                                "storageKey": null
                                              }
                                            ],
                                            "type": "AcademiesUserExtension",
                                            "abstractKey": null
                                          }
                                        ],
                                        "storageKey": "extension(userExtensionKind:\"Academies\")"
                                      }
                                    ],
                                    "storageKey": null
                                  },
                                  (v2/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v3/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "isManager",
                                "storageKey": null
                              },
                              (v7/*: any*/)
                            ],
                            "type": "UserInAccountWrapper",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Invitation",
                                "kind": "LinkedField",
                                "name": "invitation",
                                "plural": false,
                                "selections": [
                                  (v2/*: any*/),
                                  (v4/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v8/*: any*/),
                              (v7/*: any*/)
                            ],
                            "type": "InvitationWrapper",
                            "abstractKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      (v9/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PageInfo",
                    "kind": "LinkedField",
                    "name": "pageInfo",
                    "plural": false,
                    "selections": [
                      (v10/*: any*/),
                      (v11/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v8/*: any*/)
                ],
                "storageKey": "accountMembers(first:100)"
              },
              {
                "alias": null,
                "args": (v0/*: any*/),
                "filters": null,
                "handle": "connection",
                "key": "membersTab_accountMembers",
                "kind": "LinkedHandle",
                "name": "accountMembers"
              },
              (v8/*: any*/)
            ],
            "storageKey": "AccountMembers(filterByGroupIds:[])"
          },
          {
            "alias": null,
            "args": [
              {
                "kind": "Literal",
                "name": "doCalcMemberCount",
                "value": true
              },
              {
                "kind": "Literal",
                "name": "includeOwner",
                "value": true
              },
              {
                "kind": "Literal",
                "name": "includeUser",
                "value": true
              }
            ],
            "concreteType": "UserInAccountGroupWrappersResult",
            "kind": "LinkedField",
            "name": "UserInAccountGroupWrappers",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v12/*: any*/),
                "concreteType": "UserInAccountGroupWrapperConnection",
                "kind": "LinkedField",
                "name": "userInAccountGroupWrappers",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "UserInAccountGroupWrapperEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "UserInAccountGroupWrapper",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "UserInAccountGroup",
                            "kind": "LinkedField",
                            "name": "group",
                            "plural": false,
                            "selections": [
                              (v2/*: any*/),
                              (v3/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "isBuiltIn",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          (v2/*: any*/),
                          (v1/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "memberCount",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      (v9/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PageInfo",
                    "kind": "LinkedField",
                    "name": "pageInfo",
                    "plural": false,
                    "selections": [
                      (v11/*: any*/),
                      (v10/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v8/*: any*/)
                ],
                "storageKey": "userInAccountGroupWrappers(first:200)"
              },
              {
                "alias": null,
                "args": (v12/*: any*/),
                "filters": null,
                "handle": "connection",
                "key": "filterModal_userInAccountGroupWrappers",
                "kind": "LinkedHandle",
                "name": "userInAccountGroupWrappers"
              },
              {
                "alias": null,
                "args": (v12/*: any*/),
                "filters": null,
                "handle": "connection",
                "key": "groupsTab_userInAccountGroupWrappers",
                "kind": "LinkedHandle",
                "name": "userInAccountGroupWrappers"
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "count",
                "storageKey": null
              }
            ],
            "storageKey": "UserInAccountGroupWrappers(doCalcMemberCount:true,includeOwner:true,includeUser:true)"
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "AccountBaseDataQueries",
        "kind": "LinkedField",
        "name": "AccountBaseData",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "AccountBaseData",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              {
                "kind": "TypeDiscriminator",
                "abstractKey": "__isbaseData"
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "street",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "houseNumber",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "postalCode",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "city",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "countryCode",
                "storageKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "companyName",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "billingOffice",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "companyLegalForm",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "invoiceEmail",
                    "storageKey": null
                  },
                  (v13/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "AccountData",
                    "kind": "LinkedField",
                    "name": "accountData",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "bic",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "iban",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TaxData",
                    "kind": "LinkedField",
                    "name": "taxData",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "taxIdentificationNumber",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "taxNumber",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "type": "BusinessBaseData",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  (v13/*: any*/),
                  (v5/*: any*/),
                  (v6/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "salutation",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "title",
                    "storageKey": null
                  }
                ],
                "type": "PrivateBaseData",
                "abstractKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "ViewerQueryType",
        "kind": "LinkedField",
        "name": "Viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "AuthViewerSchema",
            "kind": "LinkedField",
            "name": "Auth",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "CurrentUser",
                "kind": "LinkedField",
                "name": "currentUser",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Account",
                    "kind": "LinkedField",
                    "name": "accounts",
                    "plural": true,
                    "selections": [
                      (v3/*: any*/),
                      (v2/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "AccountGroupAssociation",
                        "kind": "LinkedField",
                        "name": "groupAssociations",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "AccountGroup",
                            "kind": "LinkedField",
                            "name": "group",
                            "plural": false,
                            "selections": [
                              (v3/*: any*/),
                              (v2/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "9000da2f128c9a1e9c8d94c98a185a82",
    "id": null,
    "metadata": {},
    "name": "account_Query",
    "operationKind": "query",
    "text": "query account_Query {\n  ...membersTab_AccountMembersQueryFragment\n  ...membersTab_UserInAccountGroupQueryFragment\n  ...groupsTab_QueryFragment\n  ...groupsTab_UserInAccountGroupQueryFragment\n  ...accountTab_QueryFragment\n}\n\nfragment accountContextMenu_AuthViewerSchemaFragment on AuthViewerSchema {\n  currentUser {\n    accounts {\n      name\n      id\n    }\n  }\n  ...deleteAccountModalsFlow_AuthViewerSchemaFragment\n  ...leaveAccountModal_authViewerSchemaFragmentRef\n}\n\nfragment accountTab_QueryFragment on Query {\n  AccountBaseData {\n    AccountBaseData {\n      __typename\n      ...businessAccountForm_BaseDataFragment\n      ...privateAccountForm_BaseDataFragment\n    }\n  }\n  Viewer {\n    Auth {\n      ...accountContextMenu_AuthViewerSchemaFragment\n      currentUser {\n        accounts {\n          groupAssociations {\n            group {\n              name\n              id\n            }\n          }\n          name\n          id\n        }\n      }\n    }\n  }\n}\n\nfragment assignGroupModal_QueryFragment on Query {\n  ...standardInviteForm_QueryFragment\n}\n\nfragment batchEditGroups_QueryFragment on Query {\n  ...inviteMemberModal_QueryFragment\n}\n\nfragment batchEditMembers_QueryFragment on Query {\n  ...assignGroupModal_QueryFragment\n}\n\nfragment businessAccountForm_BaseDataFragment on baseData {\n  __isbaseData: __typename\n  street\n  houseNumber\n  postalCode\n  city\n  countryCode\n  __typename\n  ... on BusinessBaseData {\n    companyName\n    billingOffice\n    companyLegalForm\n    invoiceEmail\n    phoneNumber\n    accountData {\n      bic\n      iban\n    }\n    taxData {\n      taxIdentificationNumber\n      taxNumber\n    }\n  }\n}\n\nfragment deleteAccountModalsFlow_AuthViewerSchemaFragment on AuthViewerSchema {\n  currentUser {\n    accounts {\n      id\n      name\n    }\n  }\n}\n\nfragment editGroupModal_UserInAccountGroupFragment on UserInAccountGroup {\n  id\n  name\n}\n\nfragment filterModal_QueryFragment on Query {\n  AccountMemberManagement {\n    UserInAccountGroupWrappers(includeOwner: true, includeUser: true, doCalcMemberCount: true) {\n      userInAccountGroupWrappers(first: 200) {\n        edges {\n          node {\n            group {\n              id\n              name\n            }\n            id\n            __typename\n          }\n          cursor\n        }\n        pageInfo {\n          endCursor\n          hasNextPage\n        }\n      }\n    }\n  }\n}\n\nfragment groupCard_QueryFragment on Query {\n  ...groupContextMenu_QueryFragment\n}\n\nfragment groupCard_UserInAccountGroupWrapperFragment on UserInAccountGroupWrapper {\n  id\n  memberCount\n  group {\n    id\n    name\n    isBuiltIn\n  }\n  ...groupContextMenu_UserInAccountGroupWrapperFragment\n}\n\nfragment groupContextMenu_QueryFragment on Query {\n  ...inviteMemberModal_QueryFragment\n}\n\nfragment groupContextMenu_UserInAccountGroupWrapperFragment on UserInAccountGroupWrapper {\n  group {\n    id\n    name\n    isBuiltIn\n    ...editGroupModal_UserInAccountGroupFragment\n  }\n}\n\nfragment groupsTab_QueryFragment on Query {\n  AccountMemberManagement {\n    UserInAccountGroupWrappers(includeOwner: true, includeUser: true, doCalcMemberCount: true) {\n      count\n      userInAccountGroupWrappers(first: 200) {\n        edges {\n          node {\n            memberCount\n            group {\n              id\n              name\n              isBuiltIn\n            }\n            ...groupCard_UserInAccountGroupWrapperFragment\n            id\n            __typename\n          }\n          cursor\n        }\n        pageInfo {\n          endCursor\n          hasNextPage\n        }\n      }\n    }\n  }\n}\n\nfragment groupsTab_UserInAccountGroupQueryFragment on Query {\n  ...batchEditGroups_QueryFragment\n  ...groupCard_QueryFragment\n}\n\nfragment invitationCard_InvitationFragment on AccountMember {\n  __isAccountMember: __typename\n  ... on InvitationWrapper {\n    invitation {\n      id\n      email\n    }\n    groups {\n      id\n      name\n    }\n  }\n}\n\nfragment inviteMemberModal_QueryFragment on Query {\n  ...standardInviteForm_QueryFragment\n}\n\nfragment leaveAccountModal_authViewerSchemaFragmentRef on AuthViewerSchema {\n  currentUser {\n    accounts {\n      id\n      name\n    }\n  }\n}\n\nfragment membersFilter_QueryFragment on Query {\n  ...filterModal_QueryFragment\n}\n\nfragment membersTab_AccountMemberFragment on AccountMember {\n  __isAccountMember: __typename\n  id\n  kind\n  ... on UserInAccountWrapper {\n    user {\n      user {\n        id\n        ...userContextMenu_UserFragment\n      }\n      id\n    }\n  }\n  ... on InvitationWrapper {\n    invitation {\n      id\n      email\n    }\n  }\n  ...userCard_UserInAccountWrapperFragment\n  ...invitationCard_InvitationFragment\n}\n\nfragment membersTab_AccountMembersQueryFragment on Query {\n  AccountMemberManagement {\n    AccountMembers(filterByGroupIds: []) {\n      userCount\n      invitationCount\n      accountMembers(first: 100) {\n        edges {\n          node {\n            __typename\n            ...membersTab_AccountMemberFragment\n            id\n          }\n          cursor\n        }\n        pageInfo {\n          hasNextPage\n          endCursor\n        }\n      }\n    }\n  }\n}\n\nfragment membersTab_UserInAccountGroupQueryFragment on Query {\n  ...membersFilter_QueryFragment\n  ...inviteMemberModal_QueryFragment\n  ...batchEditMembers_QueryFragment\n  ...userContextMenu_QueryFragment\n}\n\nfragment privateAccountForm_BaseDataFragment on baseData {\n  __isbaseData: __typename\n  street\n  houseNumber\n  postalCode\n  city\n  countryCode\n  __typename\n  ... on PrivateBaseData {\n    phoneNumber\n    firstName\n    lastName\n    salutation\n    title\n  }\n}\n\nfragment standardInviteForm_QueryFragment on Query {\n  AccountMemberManagement {\n    UserInAccountGroupWrappers(includeOwner: true, includeUser: true, doCalcMemberCount: true) {\n      userInAccountGroupWrappers(first: 200) {\n        edges {\n          node {\n            group {\n              id\n              name\n            }\n            id\n            __typename\n          }\n          cursor\n        }\n        pageInfo {\n          endCursor\n          hasNextPage\n        }\n      }\n    }\n  }\n}\n\nfragment userAvatar_UserFragment on User {\n  extension(userExtensionKind: Academies) {\n    __typename\n    ... on AcademiesUserExtension {\n      firstName\n      lastName\n      avatar {\n        thumbnail\n        id\n      }\n      sumGamificationPoints\n    }\n  }\n}\n\nfragment userCard_UserInAccountWrapperFragment on UserInAccountWrapper {\n  id\n  name\n  isManager\n  groups {\n    id\n    name\n  }\n  user {\n    user {\n      id\n      name\n      email\n      ...userAvatar_UserFragment\n    }\n    id\n  }\n}\n\nfragment userContextMenu_QueryFragment on Query {\n  ...assignGroupModal_QueryFragment\n}\n\nfragment userContextMenu_UserFragment on User {\n  id\n  name\n  email\n}\n"
  }
};
})();

(node as any).hash = "44dcddc6af26092f27247818f3ea94e0";

export default node;
